import { render, staticRenderFns } from "./CareerAI.vue?vue&type=template&id=7cb3dc6c&scoped=true"
import script from "./CareerAI.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAI.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/career-ai/career-ai-base.scss?vue&type=style&index=0&id=7cb3dc6c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3dc6c",
  null
  
)

export default component.exports